import React, { Component, Fragment } from 'react';

import AllProjects from '../components/projects/allProjects';
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';

class Projects extends Component {

    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <AllProjects />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default Projects;